export default __webpack_public_path__ + "2974e9ebcd83918ebd6e96dfeff92d94.png";